import { useState } from "react";

import { setFavorites } from "@/api/endpoints/favorite";
import { postTrackingData } from "@/api/endpoints/track";
import FavoriteIcon from "@/assets/icons/favorite.svg";
import { useMentionCard } from "@/containers/MentionCard/context";
import { useTags } from "@/contexts/TagContext";
import { EVENT } from "@/tracking_events";
import { cx } from "@/utils";
import { extractMentionCardTrackingPayload } from "@/utils/tracking";
import Button from "@components/Button";

import styles from "./Favorite.module.css";

type FavoriteProps = {
  className: string;
};
const Favorite = ({ className }: FavoriteProps) => {
  const { is_favorited, ...episode } = useMentionCard();
  const { fetchOrganizationTags } = useTags() || {
    organizationTags: [],
  };
  const [isFavorited, setIsFavorited] = useState(is_favorited);

  const onMarkFavorite = () => {
    if (!isFavorited) {
      postTrackingData(
        EVENT.MARK_FAVOURITE,
        extractMentionCardTrackingPayload(episode)
      );
    }

    setIsFavorited((v) => !v);

    setFavorites(
      episode.mentions.map((m) => m.public_id),
      !isFavorited
    )
      .then(() => {
        fetchOrganizationTags();
      })
      .catch((error) => {
        throw error;
      });
  };
  return (
    <Button
      data-testid="mark-favorite-button"
      variant="tertiary"
      className={cx(styles.root, className)}
      iconProps={{
        fill: isFavorited ? "currentColor" : "transparent",
      }}
      icon={FavoriteIcon}
      onClick={onMarkFavorite}
    />
  );
};

export default Favorite;
